import script from "./jobDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./jobDetail.vue?vue&type=script&setup=true&lang=js"

import "./jobDetail.vue?vue&type=style&index=0&id=9a2c1b82&lang=less&scoped=true"

import exportComponent from "/Users/liuxiong/Documents/美通官网/huanshuntong/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a2c1b82"]])

export default __exports__